<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <mat-card appearance="outlined">
    <ng-container *ngFor="let orphan of orphanData | keyvalue">
      <mat-expansion-panel *ifPrivilege="orphan['value']['privilege']">
        <mat-expansion-panel-header>
          <mat-panel-title>{{orphan['value']['description']}}
            <span *ngIf="orphan['value']['info'].running"> - loading ({{orphan['value']['info'].checked}} / {{orphan['value']['info'].total}})... </span>
            <span *ngIf="orphan['value']['items'].length || orphan['value']['info'].done"> - found {{orphan['value']['items'].length}}
              dead {{orphan.key}}</span>
          </mat-panel-title>
          <mat-panel-description></mat-panel-description>
        </mat-expansion-panel-header>
        <button (click)="getOrphans(orphan.key)" *ngIf="!orphan['value']['items'].length || isCanceled" class="ibexfusion-raised-button"
                mat-raised-button>get Orphans
        </button>
        <button (click)="removeAll(orphan['value']['service'], orphan['value']['items'])" *ngIf="!orphan['value']['info'].running && orphan['value']['items'].length" class="ibexfusion-raised-button"
                mat-raised-button>remove All
        </button>
        <button (click)="cancel()" *ngIf="orphan['value']['info'].running || orphan['value']['info'].done" class="ibexfusion-raised-button"
                mat-raised-button>cancel
        </button>
        <div class="spacer"></div>
        <div *ngIf="orphan['value']['items'] && orphan['value']['items'].length && !orphan['value']['info'].running">
          <mat-list *ngFor="let item of orphan['value']['items']" class="installedWidgets">
            <mat-list-item>{{item._id}}:</mat-list-item>
            <mat-list-item>
              <span>Created:  {{ item.created | date: 'dd MMMM yyyy'}},</span>
              <span *ngIf="item.translations && item.translations.length">
                  Translations:  <span *ngFor="let translation of item.translations">{{translation.title || translation.appTitle}}, </span>
                </span>
              <span *ngIf="item.title">Title: {{item.title}}, </span>
              <span *ngIf="item.children">Children: {{item.children.length}}, </span>
              <span *ngIf="item.type">Type: {{item.type}}</span>
            </mat-list-item>
            <button (click)="removeOne(orphan['value']['service'], item._id, orphan['value']['items'])" class="ibexfusion-raised-button"
                    mat-raised-button>remove
            </button>
          </mat-list>
        </div>
      </mat-expansion-panel>
      <div *ifPrivilege="orphan['value']['privilege']" class="spacer"></div>
    </ng-container>

    <mat-expansion-panel *ifPrivilege="{name: 'read', value: 'imports'}">
      <mat-expansion-panel-header>
        <mat-panel-title>Unassigned Importer (!does not check meta importer)</mat-panel-title>
        <mat-panel-description></mat-panel-description>
      </mat-expansion-panel-header>
      <p class="warn">Warning: this function needs a lot of requests, use it only if you really have to!</p>
      <button (click)="getUnassignedImporters(0, 1000)" class="ibexfusion-raised-button" mat-raised-button>get from 0 to 999</button>
      <button (click)="getUnassignedImporters(1000, 1999)" class="ibexfusion-raised-button" mat-raised-button>get from 1000 to 1999</button>
      <button (click)="getUnassignedImporters(2000, 2999)" class="ibexfusion-raised-button" mat-raised-button>get from 2000 to 2999</button>
      <button (click)="getUnassignedImporters(3000, 3999)" class="ibexfusion-raised-button" mat-raised-button>get from 3000 to 3999</button>
      <div *ngIf="unassignedImporters.length">
        <p>Found {{unassignedImporters.length}} unassigned importers</p>
        <mat-list *ngFor="let item of unassignedImporters">
          <mat-list-item>{{item._id}}:</mat-list-item>
          <mat-list-item>Title: {{item.title}}, TypeId: {{item.typeId}}</mat-list-item>
          <button (click)="removeOne(importService, item._id, unassignedImporters)" class="ibexfusion-raised-button" mat-raised-button>
            remove
          </button>
        </mat-list>
      </div>
    </mat-expansion-panel>
  </mat-card>
</page-content>
